export default "__VITE_ASSET__18632097__"